import { POST_STYLE_TOKEN_CLASSES, styleToRenderTokens } from './post-style-tokens.js';

const POST_STYLE_CSS_VAR_KEYS = [
  '--post-fg',
  '--post-bg',
  '--post-font-family',
  '--post-font-size'
];

function stripTokenClasses(className) {
  const tokens = new Set(POST_STYLE_TOKEN_CLASSES);
  return className
    .split(/\s+/)
    .filter((cls) => cls && !tokens.has(cls))
    .join(' ');
}

function setPostStyleCssVars(element, cssVars = {}) {
  for (const key of POST_STYLE_CSS_VAR_KEYS) {
    if (cssVars[key]) {
      element.style.setProperty(key, cssVars[key]);
    } else {
      element.style.removeProperty(key);
    }
  }
}

function clearPostStyleCssVars(element) {
  for (const key of POST_STYLE_CSS_VAR_KEYS) {
    element.style.removeProperty(key);
  }
}

export function applyPostStyleTokens(element, style) {
  if (!element) return;

  if (element.dataset.postStyleBase === undefined) {
    element.dataset.postStyleBase = stripTokenClasses(element.className);
  }

  const base = element.dataset.postStyleBase || '';
  const { classes, cssVars } = styleToRenderTokens(style);

  if (!style) {
    element.className = base;
    clearPostStyleCssVars(element);
    return;
  }

  element.className = [base, 'post-item', ...classes].filter(Boolean).join(' ');
  setPostStyleCssVars(element, cssVars);
}

export function clearPostStyleTokens(element) {
  if (!element) return;

  const base = element.dataset.postStyleBase;
  if (base !== undefined) {
    element.className = base;
    delete element.dataset.postStyleBase;
  }
  clearPostStyleCssVars(element);
}
